var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.29289 2.29289C1.68342 1.90237 2.31658 1.90237 2.70711 2.29289L8 7.58579L13.2929 2.29289C13.6834 1.90237 14.3166 1.90237 14.7071 2.29289C15.0976 2.68342 15.0976 3.31658 14.7071 3.70711L8.70711 9.70711C8.31658 10.0976 7.68342 10.0976 7.29289 9.70711L1.29289 3.70711C0.902369 3.31658 0.902369 2.68342 1.29289 2.29289Z","fill":"black"}));
}

ChevronDown.defaultProps = {"width":"16","height":"12","viewBox":"0 0 16 12","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
